<h2 class="mbottom-12">
  {{ 'commercialCommon.scaSpinner.pleaseAuthenticateYourCreditCard' | transloco }}
</h2>

<yat-payment-method-polling-ui
  [pollingConfiguration]="pollingConfiguration"
  [pollText]="'commercialCommon.scaSpinner.waitingForCreditCardAuthentication' | transloco"
  (cancel)="cancel()">
</yat-payment-method-polling-ui>
